import { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Post, RecommendedUsers, HomeSearch, User } from '../components';
import AppContext from '../context/AppContext';

import { pageAnimation } from '../animation';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import useApi from '../hooks/useApi';
import postApi from '../api/post';

export default function Search() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const getPosts = useApi(postApi.search);
  const getUsers = useApi(postApi.search);

  const keyword = location.search.split('=')[1];
  const [activeTab, setActiveTab] = useState('Posts');

  const {
    currentAccount,
    theme,
    isLoggedIn,
    isMember,
    hasLoaded,
    accountDetails,
  } = useContext(AppContext);

  useEffect(() => {
    if (hasLoaded) {
      if (!isLoggedIn) {
        navigate('/connect');
      } else if (!isMember) {
        navigate('/create-profile');
      } else {
      }
    }
  }, [isMember, isLoggedIn, hasLoaded]);

  useEffect(() => {
    if (activeTab === 'Posts' || 'Shorts') {
      getPosts.request({
        query: `${keyword || 'hello'}`,
        type: 'PUBLICATION',
        limit: 10,
      });
    } else {
      getUsers.request({
        query: `${keyword || 'josh'}`,
        type: 'PROFILE',
        limit: 10,
      });
    }
  }, [keyword, activeTab]);

  const searchedPosts = getPosts.data?.search?.items;
  const searchedUsers = getUsers.data;
  console.log('SEARCHED POSTS', searchedPosts);
  console.log('SEARCHED USERS', searchedUsers);
  const tabs = ['Posts', 'Shorts', 'Users'];
  return (
    <StyledSearch
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      theme_={theme}
    >
      <>
        <div className="left">
          <div className="header">
            <span
              onClick={() => navigate(`${location?.state?.path || '/'}`)}
              className="back"
            >
              <KeyboardBackspaceIcon />
            </span>

            <HomeSearch />
          </div>

          <span className="tabs">
            {tabs.map((tab, index) => (
              <span
                className={`tab ${activeTab === tab && 'active'}`}
                key="index"
                onClick={() => setActiveTab(tab)}
              >
                {tab}
                <div className="line"></div>
              </span>
            ))}
          </span>
          {activeTab === 'Posts' &&
            (searchedPosts?.length > 0 ? (
              <div className="posts">
                {searchedPosts?.map((post, index) => {
                  return (
                    post.__typename === 'Post' && (
                      <Post post={post} key={index} />
                    )
                  );
                })}
              </div>
            ) : (
              <span className="no-posts">
                <h2>No Found Post</h2>
              </span>
            ))}
          {activeTab === 'Shorts' &&
            (searchedPosts?.length > 0 ? (
              <div className="posts">
                {searchedPosts?.map((post, index) => {
                  return (
                    post.__typename === 'Post' &&
                    post?.metadata?.media[0]?.original?.mimeType?.startsWith(
                      'video'
                    ) && <Post post={post} key={index} />
                  );
                })}
              </div>
            ) : (
              <span className="no-posts">
                <h2>No Found Short</h2>
              </span>
            ))}
          {activeTab === 'Users' &&
            (searchedUsers?.length > 0 ? (
              <div className="posts">
                {searchedUsers?.map((user, index) => {
                  return (
                    user.__typename === 'Profile' && (
                      <User user={user} key={index} />
                    )
                  );
                })}
              </div>
            ) : (
              <span className="no-posts">
                <h2>No User Found</h2>
              </span>
            ))}
        </div>
        <div className="right">
          <RecommendedUsers />
        </div>
      </>
    </StyledSearch>
  );
}
const StyledSearch = styled(motion.div)`
  display: flex;
  flex-flow: row wrap;
  position: fixed;
  width: 80%;
  right: 0;
  top: 0;
  height: 100%;
  overflow-y: scroll;
  @media screen and (max-width: 900px) {
    position: absolute;
    width: 100%;
    padding-bottom: 15%;
  }
  .left {
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    clip-path: inset(0px -15px 0px 0px);
    width: 60%;
    display: flex;
    flex-flow: column wrap;
    @media screen and (max-width: 900px) {
      width: 100%;
    }
    .header {
      display: flex;
      gap: 1rem;
      align-items: center;
      position: sticky;
      top: 0;
      padding: 1rem 2rem;
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(15, 15, 15,0.8)' : 'rgb(255, 255, 255,0.8)'};
      .back {
        cursor: pointer;
      }
      z-index: 2;
      @media screen and (max-width: 900px) {
        display: flex;
        gap: 1rem;
        align-items: center;
        padding: 0.8rem 1rem;
      }
    }
    .photo-cont {
      height: 13rem;
      position: relative;
      margin-bottom: 4.5rem;
      .cover {
        display: block;
        object-fit: cover;
        height: 100%;
        width: 100%;
      }

      .dp {
        position: absolute;
        bottom: -28%;
        left: 50%;
        transform: translateX(-50%);
        width: 8.5rem;
        height: 8.5rem;
        border-radius: 50%;
        border: 5px solid ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
        overflow: hidden;
        display: flex;

        cursor: pointer;
        background: ${({ theme_ }) =>
          theme_ ? 'rgb(15, 15, 15,1)' : 'rgb(255, 255, 255,1)'};
        img {
          width: 100%;
          object-fit: cover;
          display: block;
        }
        .edit {
          display: none;
          color: white;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 2rem;
        }
        &:hover {
          img {
            opacity: 0.8;
          }

          .edit {
            display: block;
          }
        }
      }
    }

    img {
      display: block;
      width: 100%;
    }
    .details {
      display: flex;
      flex-flow: column wrap;
      gap: 0.7rem;
      align-items: center;
      padding-bottom: 2rem;
      .bio {
        padding: 0rem 2rem;
      }
    }
  }

  .right {
    width: 40%;
    padding: 1rem 1rem;
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    position: sticky;
    top: 0;
    right: 0;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .posts {
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    padding: 1rem 1rem;
    @media screen and (max-width: 900px) {
      gap: 0rem;
      padding: 0rem 0rem;
      width: 100%;
    }
  }
  .no-posts {
    display: flex;
    justify-content: center;
    padding: 3rem 0rem;
  }

  .tabs {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    width: 100%;
    .tab {
      padding: 0rem 2rem;
      padding-top: 0.5rem;
      font-size: 1.2rem;
      cursor: pointer;
      &:hover {
        color: gray;
      }
      .line {
        margin-top: 0.5rem;
        padding: 2px;
        background: inherit;
        border-radius: 3rem 3rem 0px 0px;
      }
      &.active {
        .line {
          background: #50c1e9;
        }
      }
    }
  }
  .tabs {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;

    width: 100%;
    .tab {
      padding: 0rem 2rem;
      padding-top: 0.5rem;
      font-size: 1.2rem;
      cursor: pointer;
      &:hover {
        color: gray;
      }
      .line {
        margin-top: 0.5rem;
        padding: 2px;
        background: inherit;
        border-radius: 3rem 3rem 0px 0px;
      }
      &.active {
        .line {
          background: #50c1e9;
        }
      }
    }
  }
`;
